import Footer from "../components/Footer/Footer";
import Pricing from "../components/Pricing/Pricing";
import { FaBolt } from "react-icons/fa6";

function Price() {
  return (
    <>
      <section className="bg-[#060608] text-white mt-16 min-h-screen">
        {/* Dynamic Atmospheric Page Header */}
        <div
          className="relative pt-32 pb-16 sm:pt-36 sm:pb-20 border-b border-neutral-800/80 overflow-hidden text-center"
          style={{
            background: "radial-gradient(ellipse at 50% 0%, #200f38 0%, #0d0c14 60%, #060608 100%)",
          }}
        >
          {/* Ambient Lighting Orbs */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-gradient-to-r from-red-600/15 via-yellow-500/15 to-transparent rounded-full blur-[120px] pointer-events-none"></div>

          <div className="container relative z-10 mx-auto px-4">
            <div className="inline-flex items-center gap-2 bg-neutral-900/90 border border-neutral-700/80 rounded-full px-4 py-1.5 mb-4 shadow-lg backdrop-blur-md">
              <FaBolt className="text-[#ffd600] text-[12px]" />
              <span className="text-[11px] sm:text-[12px] uppercase font-bold tracking-widest text-neutral-200">
                FAT2FIT Unisex Fitness Centre • Echanari, Coimbatore
              </span>
            </div>

            <h1 className="text-[34px] sm:text-[46px] md:text-[54px] font-black uppercase tracking-tight text-white mb-3">
              Membership <span className="bg-gradient-to-r from-[#ffd600] via-yellow-400 to-[#ff0336] bg-clip-text text-transparent">Pricing &amp; Offers</span>
            </h1>
            <p className="text-neutral-300 text-[14.5px] sm:text-[16.5px] max-w-xl mx-auto font-medium leading-relaxed">
              Flexible options engineered to help you reach your goals. Choose your plan and start training today.
            </p>
          </div>
        </div>

        {/* Pricing Component */}
        <Pricing />

        {/* Footer */}
        <Footer />
      </section>
    </>
  );
}

export default Price;
